import React, { forwardRef } from "react"
import "./style.scss"
import fr from "react-phone-input-2/lang/fr.json"
import "react-phone-input-2/lib/high-res.css"
import PI from "react-phone-input-2"
import PropTypes from "prop-types";
import { PhoneNumberUtil } from "google-libphonenumber"
import { BJPREFIX } from "@/utils/utils"

const phoneUtil = PhoneNumberUtil.getInstance();

const validateBjPhoneNumber = (phoneNumber) => {
  if (phoneNumber.slice(3, 5) === "01") {
    const phoneNumberWithoutPrefix = phoneNumber.slice(5)
    const parsedPhoneNumber = phoneUtil.parse(phoneNumberWithoutPrefix, "BJ")
    let isValidNumber = phoneUtil.isValidNumber(parsedPhoneNumber)
    if (!isValidNumber) {
      const prefix = phoneNumber.slice(5, 7);
      isValidNumber = BJPREFIX.includes(prefix);
    }
    return isValidNumber
  }
  return "Veuillez préfixer le numéro de 01";
}

export const handleValidate = (value, countryCode) => {
  const number = phoneUtil.parse(value, countryCode);
  const isValidNumber = phoneUtil.isValidNumber(number);
  if (countryCode === "bj" && !isValidNumber) {
    try{
      return validateBjPhoneNumber(value)
    } catch (error) {

    }
  }
  return isValidNumber;
};

const PhoneInput = (
  { defaultCountry = "bj", value, onChange, isCodeEditable = false },
  ref,
) => {
  const ReactPhoneInput = PI.default ? PI.default : PI;

  return (
    <ReactPhoneInput
      country={defaultCountry}
      localization={fr}
      autocompleteSearch
      value={value}
      onChange={onChange}
      masks={{ bj: ".. .. .. .. .." }}
      containerClass="custom-phone-wrapper"
      inputClass="custom-phone-input"
      buttonClass="custom-phone-btn"
      buttonStyle={{ borderRadius: "4px 0 0 4px" }}
      searchStyle={{ margin: "0", width: "97%", height: "30px" }}
      countryCodeEditable={false}
      enableSearch
      disableSearchIcon
    />
  );
};

export default forwardRef(PhoneInput);

PhoneInput.propTypes = {
  defaultCountry: PropTypes.string,
  isCodeEditable: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
};
